import { Columns } from '../../constants/myCampaigns.js';

export const REQUIRED_COLUMNS = [
  Columns.BUDGET,
  'compound_budget',
  'date_from',
  'date_to',
  'media',
];

export const NOT_EDITABLE_COLUMNS = ['adserver_cost', 'dsp_cost'];

export enum ADSERVER_COST {
  DIM = 'adserver_cost',
  COL = 'Adserver cost',
}

export enum DSP_COST {
  DIM = 'dsp_cost',
  COL = 'DSP cost',
}

export const NOT_INTEGRATED_COLUMNS = [
  'adserver_cost',
  'dsp_cost',
  'Adserver cost',
  'DSP cost',
  'Other tech costs',
];

export const DEPENDENT_COLUMNS: Record<string, string[]> = {
  pricing_type: ['pricing_value'],
  pricing_value: ['pricing_type'],
};

export const HIDDEN_COLUMNS = ['platform_media', 'channel'];

export const DimensionsDragType = {
  DIMENSION_ROW: 'DIMENSION_ROW',
  GROUPED_DIMENSION: 'GROUPED_DIMENSION',
  SELECT_OPTION: 'SELECT_OPTION',
} as const;

export const DECIMAL_SCALE = 2;
export const MIN_OPTIONS_COUNT = 1;
